class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    // Listen to 'mouseenter' event and trigger the custom 'expand' event
    this.addEventListener('mouseenter', () => {
      this.dispatchEvent(new CustomEvent('expand'));
    });

    // Listen to 'mouseleave' event and trigger the custom 'collapse' event
    this.addEventListener('mouseleave', () => {
      this.dispatchEvent(new CustomEvent('collapse'));
    });
  }

  connectedCallback() {
    // Listen to the custom 'expand' and 'collapse' events and call the respective methods
    this.addEventListener('expand', this.expand.bind(this));
    this.addEventListener('collapse', this.collapse.bind(this));
  }

  expand() {
    if (!this.animations) this.animations = this.content.getAnimations();

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.animations.forEach((animation) => animation.play());
  }

  collapse() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    if (this.animations) {
      this.animations.forEach((animation) => animation.cancel());
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  // Remove onToggle() method from HeaderMenu, as it's not needed anymore.

  connectedCallback() {
    super.connectedCallback();
    // Listen to the custom 'expand' and 'collapse' events and call the respective methods
    this.addEventListener('expand', this.open.bind(this));
    this.addEventListener('collapse', this.close.bind(this));
  }

  open() {
    if (!this.header) return;
    this.header.preventHide = true; // Prevent hiding when mouse leaves the header

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    if (!this.header) return;
    this.header.preventHide = false; // Reset the preventHide property

    // Also reset the '--header-bottom-position-desktop' style when the menu closes
    document.documentElement.style.setProperty('--header-bottom-position-desktop', '');
  }
}

customElements.define('header-menu', HeaderMenu);
